import {formatDate} from 'common/helpers'
import {CashflowList, CashflowForecastValue} from '..'

interface CashflowMonthDetailsProps {
  value: CashflowForecastValue
  cahsflowForecast: any
}

export default function CashflowMonthDetails({
  value,
  cahsflowForecast,
}: CashflowMonthDetailsProps) {
  return (
    <CashflowList
      isMonthDetails
      cashflowItems={getCashflowItems(
        formatDate(value.monthDate, 'serverSecond'),
        cahsflowForecast
      )}
      drawdownsCount={value.drawdownsCount}
      repaymentsCount={value.repaymentsCount}
      drawdownsAmount={value.drawdownsAmount}
      repaymentsAmount={value.repaymentsAmount}
    />
  )
}

const getCashflowItems = (month: string, cahsflowForecast: any): any[] =>
  cahsflowForecast.projects
    .filter((project: any) => Boolean(project.forecastItems[month]))
    .map((project: any) => {
      let forecastItems: any[] = []
      const itemsObject = project.forecastItems[month]
      if (itemsObject.drawdown) {
        forecastItems = [
          ...itemsObject.drawdown.map((item: any) => ({
            ...item,
            projectTitle: project.title,
            source: 'forecast',
            type: 'drawdown',
          })),
        ]
      }
      if (itemsObject.repayment) {
        forecastItems = [
          ...forecastItems,
          ...itemsObject.repayment.map((item: any) => ({
            ...item,
            projectTitle: project.title,
            source: 'forecast',
            type: 'repayment',
          })),
        ]
      }
      return forecastItems
    })
    .flat()
